import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'designPhoto',
  title: 'Design Photo',
  type: 'object',
  fields: [
    defineField({
      name: 'photo',
      title: 'Photo',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      name: 'finish',
      title: 'Finish',
      type: 'reference',
      to: [{ type: 'finish' }],
      options: {
        disableNew: true,
      },
    }),
  ],
  preview: {
    select: {
      finish: 'finish.name',
      //   photo: 'photo',
    },
    prepare(selection: any) {
      const { photo = false, finish = 'New Finish' } = selection || {}

      return {
        title: finish,
        subtitle: '',
        // media,
      }
    },
  },
})